import { cn } from '@bem-react/classname';

export const cnGrid = cn('Grid');
